import { useLazyQuery } from '@apollo/client'
import { Edit as Pencil } from '@mui/icons-material'
import { Box, Divider, IconButton, Typography } from '@mui/material'
import { Fragment, useState } from 'react'
import { DownloadCompanyDocument } from 'recruiter/graphql/companies.gql'
import useToast from 'shared/components/Toast/useToast'
import useIsMobile from 'shared/hooks/useIsMobile'
import theme from 'shared/style/theme'
import { getPxAsRem } from 'shared/utils'
import EditCompanyDocuments from '../EditCompanyDocuments'
import { Header, StyledCard } from './styled'

const CompanyDocumentsCard = ({ data, refetch }) => {
    const [download] = useLazyQuery(DownloadCompanyDocument, {
        fetchPolicy: 'network-only',
    })
    const isMobile = useIsMobile()
    const toast = useToast()
    const [edit, setEdit] = useState(false)
    const handleDownloadClick = async (id: string) => {
        try {
            const { data } = await download({ variables: { documentId: id } })
            console.log(data?.downloadCompanyDocument?.url)
            if (data?.downloadCompanyDocument?.url) {
                const hiddenDownloadLink = document.createElement('a')
                hiddenDownloadLink.href = data.downloadCompanyDocument.url
                hiddenDownloadLink.target = '_blank'
                hiddenDownloadLink.click()
                hiddenDownloadLink.remove()
            } else {
                toast({
                    title: 'Something went wrong',
                    message: 'Please try again later.',
                })
            }
        } catch (error) {
            console.log(error)
            toast({
                title: 'Something went wrong',
                message: 'Please try again later.',
            })
        }
    }

    const formatDocumentKey = (docKey: string) => {
        // remove the folder path and candidateId from the document key (if present, seed data doesn't have it)
        if (docKey.includes('/')) {
            const splitDocKey = docKey.split('/')
            return splitDocKey[splitDocKey.length - 1]
        } else {
            return docKey
        }
    }

    const documents = data.company?.documents || []
    if (!isMobile)
        return (
            <Fragment>
                <EditCompanyDocuments
                    open={edit}
                    onClose={() => {
                        setEdit(false)
                        refetch()
                    }}
                    documents={documents}
                    refetch={refetch}
                />
                <StyledCard>
                    <Header>
                        <Typography variant="h4">Documents</Typography>
                        <IconButton size="small" onClick={() => setEdit(!edit)}>
                            <Pencil fontSize="small" />
                        </IconButton>
                    </Header>

                    <Box>
                        {documents.length > 0 ? (
                            documents.map((doc, index) => (
                                <div
                                    key={doc.id}
                                    onClick={() => handleDownloadClick(doc.id)}
                                >
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            py: getPxAsRem(8),
                                        }}
                                        color={theme.palette.primary.main}
                                    >
                                        {formatDocumentKey(doc.documentKey)}
                                    </Typography>
                                    {index < documents.length - 1 && (
                                        <Divider />
                                    )}
                                </div>
                            ))
                        ) : (
                            <Typography
                                variant="body1"
                                textAlign="center"
                                sx={{ padding: getPxAsRem(12) }}
                            >
                                No documents available.
                            </Typography>
                        )}
                    </Box>
                </StyledCard>
            </Fragment>
        )
}

export default CompanyDocumentsCard
